import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import style from './style.module.less';

export const DashPlaceholder = ({ alignment = 'start' }) => <span className={classnames(style.placeholder, style[alignment])}>--</span>;

DashPlaceholder.propTypes = {
  alignment: PropTypes.oneOf(['start', 'end', 'center']),
};
